// components/CustomDrawer/CustomDrawer.jsx
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../contexts/ThemeContext";

const CustomDrawer = ({ isOpen, onClose, title, children }) => {

  const { isDark, setIsDark } = useTheme();
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
          />

          {/* Drawer */}
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ 
              type: "spring",
              damping: 25,
              stiffness: 300
            }}
            className={`
              fixed bottom-0 left-0 right-0 
              h-[85vh] md:h-[80vh] 
              ${isDark ? "bg-dark-secondary" : "bg-light-secondary"}
              rounded-t-[32px] 
              p-6 md:p-8 
              z-50 
              overflow-hidden
              shadow-2xl
              ${isDark ? "border-dark-border" : "border-light-border"}
            `}
          >
            {/* Handle */}
            <div className={`absolute top-3 left-1/2 -translate-x-1/2 w-12 h-1.5 ${
              isDark ? "bg-gray-700" : "bg-gray-300"
            } rounded-full`} />

            {/* Header */}
            <div className="flex items-center justify-center mb-4  pt-2">
              <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className={`text-2xl md:text-3xl font-bold ${
                  isDark ? "text-white" : "text-gray-900"
                }`}
              >
                {title}
              </motion.h2>
            </div>

            {/* Content */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className={`overflow-y-auto h-[calc(100%-5rem)] custom-scrollbar ${
                isDark ? "text-gray-200" : "text-gray-800"
              }`}
            >
              {children}
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CustomDrawer;